import { Button, Container, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Paper, Select, TextField, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import SideDrawer from "../header/SideDrawer";
import { Box } from "@mui/system";
import DownloadIcon from '@mui/icons-material/Download';
import { API_URL } from "../../Constants";
import { axiosClient, axiosClientReports } from "../AxiosClient";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonDownloand = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    margin: '1rem auto',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const TextMessage = styled(FormHelperText)({
    color: "red",
})

export default function Reportes(){
    const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const reports = ['Reporte Experian','Reporte Comercio','Reporte Fondeo'];
    const [reporte, setReporte] = useState("");
    const [mes, setMes] = useState("");
    const [errorReport, setErrorReport] = useState(false);
    const [errorMes, setErrorMes] = useState(false);
    const [commerces, setCommerces] = useState([]);
    const [commerceId, setCommerceId] = useState("");
    const [errorCommerceId, setErrorCommerceId] = useState(false)
    const urlApi = API_URL;
    const [nameCommerce, setNameCommerce] = useState("");
    const [fondeadores, setFondeadores] = useState([]);
    const types = {
        experian: "Reporte Experian",
        comercio: "Reporte Comercio",
        fondeo: 'Reporte Fondeo'
    }
    const [fondeadorUuid, setFondeadorUuid] = useState("");
    const [fondeadorName, setFondeadorName] = useState("");
    const [fondeador, setFondeador] = useState();
    const [errorFondeadorUuid, setErrorFondeadorUuid] = useState(false);
    const [year, setYear] = useState("");
    //const urlReports = 'https://pramireportes-dev.fl0.io';
    const [errorYear, setErrorYear] = useState(false);
    const urlReports = 'https://st4igt7q7il255yy34adhbrzqa0wxxin.lambda-url.us-east-2.on.aws';
    const tiposContrato = {
        mandato: "MANDATO",
        mutuo: "MUTUO"
    };
    
    const handleChangeReporte = (event) => {
        setReporte(event.target.value)
    }

    const handleChangeMes = (event) => {
        setMes(event.target.value)
    }

    const handleChangeCommerceId = (event) => {
        setCommerceId(event.target.value)
        console.log(event)
    }

    const handleChangeFondeadorUuid = (event) => {
        setFondeadorUuid(event.target.value)
    }

    const handleChangeYear = (event) => {
        setYear(event.target.value);
    }

    const generateReportExperian = () => {
        const year = new Date().getFullYear()
        axiosClient.get(`/v1/reports/experian/excel/${mes.toLowerCase()}`, {
            responseType: 'blob'
        })
        .then(response => {
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const blobUrl = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.download = `experian_${mes.toLowerCase()}_${year}.xlsx`;
                anchor.href = blobUrl;
                anchor.dataset.downloadurl = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', anchor.download, anchor.href].join(':');
                anchor.click();
                URL.revokeObjectURL(blobUrl);
            } else {
                console.log("Error en la descarga");
            }
        })
        .catch(error => {
            console.log('Bad request: ' + error.message);
        });
    }

    const generateReportCommerce = () => {
        const url = `/reports/commerces/excel/${commerceId}/${mes}/${year}`;
        console.log('[Reporte Comercio] Request:', { commerceId, mes, year, url });
        axiosClientReports.get(url, {
            responseType: 'blob'
        })
        .then(response => {
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const blobUrl = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.download = `${nameCommerce}${mes}${year}.xlsx`;
                anchor.href = blobUrl;
                anchor.dataset.downloadurl = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', anchor.download, anchor.href].join(':');
                anchor.click();
                URL.revokeObjectURL(blobUrl);
            } else {
                console.log("Error en la descarga");
            }
        })
        .catch(error => {
            console.log('Bad request: ' + error.message);
        });
    }

    const generateFondeadoresReport = () => {

        if(fondeador.tipoContrato === tiposContrato.mutuo) {
            axiosClientReports.get(`/reports/fondeadores/excel/informacion/${fondeadorUuid}/${mes}/${year}`, {
                responseType: 'blob'
            })
            .then(response => {
                if (response.status === 200) {
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const blobUrl = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.download = `${fondeadorName}${mes}${year}.xlsx`;
                    anchor.href = blobUrl;
                    anchor.dataset.downloadurl = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', anchor.download, anchor.href].join(':');
                    anchor.click();
                    URL.revokeObjectURL(blobUrl);
                } else {
                    console.log("Error en la descarga");
                }
            })
            .catch(error => {
                console.log('Bad request: ' + error.message);
            });
        } else {
            axiosClientReports.get(`/reports/fondeadores/excel/${fondeadorUuid}/${mes}/${year}`, {
                responseType: 'blob'
            })
            .then(response => {
                if (response.status === 200) {
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const blobUrl = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.download = `${fondeadorName}${mes}${year}.xlsx`;
                    anchor.href = blobUrl;
                    anchor.dataset.downloadurl = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', anchor.download, anchor.href].join(':');
                    anchor.click();
                    URL.revokeObjectURL(blobUrl);
                } else {
                    console.log("Error en la descarga");
                }
            })
            .catch(error => {
                console.log('Bad request: ' + error.message);
            });
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if(reporte == ""){
            setErrorReport(true);
        } else {
            setErrorReport(false);
        }
        if(mes == ""){
            setErrorMes(true);
        } else {
            setErrorMes(false);
        }
        if(commerceId == "" && reporte == "Reporte Comercio"){
            setErrorCommerceId(true)
        } else {
            setErrorCommerceId(false)
        }
        if(fondeadorUuid == "" && reporte == "Reporte Fondeo"){
            setErrorFondeadorUuid(true)
        } else {
            setErrorFondeadorUuid(false)
        }
        if(year == "" || isNaN(year)){
            setErrorYear(true)
        } else {
            setErrorYear(false)
        }
        if(reporte != "" && mes != ""){
            switch(reporte) {
                case "Reporte Experian":
                    generateReportExperian();
                    setReporte("");
                    setMes("");
                    setCommerceId("")
                    setYear("")
                    break;
                case "Reporte Comercio":
                    if(commerceId != ""){
                        generateReportCommerce()
                        setReporte("");
                        setMes("");
                        setCommerceId("")
                        setNameCommerce("")
                        setYear("")
                    }
                    break;
                case "Reporte Fondeo":
                    if(fondeadorUuid != ""){
                        generateFondeadoresReport()
                        setReporte("");
                        setMes("")
                        //setFondeadorUuid("")
                        setFondeadorName("")
                        setYear("")
                    }
                    break;
                default:
                    console.log("Error al generar reporte")
                    setReporte("");
                    setMes("");
                    setCommerceId("")
                    setYear("")
            }
        }
    }

    const getCommerces = () => {
        axiosClient.get('/v1/commerces/all-commerces')
        .then(response => {
            if (response.status === 200) {
                const sortedCommerces = response.data.sort((a, b) => a.oldId - b.oldId);
                setCommerces(sortedCommerces);
            } else {
                console.log("Error in fetch");
            }
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });
    }

    const handleClickCommerce = (nameCommerce) => {
        setNameCommerce(nameCommerce)
    }

    const handleFondeadorClick = (fondeador) => {
        setFondeadorName(fondeador.name)
        setFondeador(fondeador)
    }

    const getFondeadores = () => {
        axiosClient.get('/v1/fondeadores/all')
        .then(response => {
            if (response.status === 200) {
                setFondeadores(response.data);
            } else {
                console.log("Error in fetch");
            }
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });
    }

    useEffect(() => {
        if(localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }
        getCommerces()
        getFondeadores()
    }, [])

    useEffect(() => {
            setCommerceId("")
            setErrorCommerceId(false)
            //setFondeadorUuid("")
            setErrorReport(false)
            setErrorMes(false)
            setMes("")
            setErrorYear(false)
            setErrorYear("")
    },[reporte])

    console.log(fondeadorUuid)

    return(
        <React.Fragment>
            {/* <Header name={"admin"} position="fixed" /> */}
            {/* <SideDrawer currentPage={'Reportes'}></SideDrawer> */}
            <br></br>
            <Box sx={{width: '100%', marginTop: '1.7rem'}}>
            <Container sx={{margin: 'auto', width: '70vw'}} >
                <Item>.</Item>
                <Item></Item>
                <Grid container spacing={4} mt={2}>
                    <Grid item>
                        <h1>Reportes</h1>
                    </Grid>
                </Grid>
                <Box container sx={{width: '100%', textAlign: 'center'}} >
                    <form onSubmit={handleSubmit}>
                        <Box mt={5} mb={2}>
                            <FormControl fullWidth sx={{textAlign: 'start'}}>
                                <InputLabel id="tipo-Reporte">Tipo de reporte</InputLabel>
                                <Select labelId="tipoReporte" id="select-Reporte" label='Tipo de reporte' value={reporte} onChange={handleChangeReporte}>
                                    {reports.map(reporte => (
                                        <MenuItem key={reporte} value={reporte}>{reporte}</MenuItem>
                                    ))}
                                </Select>
                                {errorReport && <TextMessage>Seleccionar tipo de reporte</TextMessage>}
                            </FormControl>
                        </Box>
                        <Box mt={7} mb={2}>
                            <FormControl fullWidth sx={{textAlign: 'start'}}>
                                <InputLabel id="mes">Mes</InputLabel>
                                <Select labelId="mes" id="select-mes" label='Mes' value={mes} onChange={handleChangeMes}>
                                    {months.map(month => (
                                        <MenuItem key={month} value={month}>{month}</MenuItem>
                                    ))}
                                </Select>
                                {errorMes && <TextMessage>Seleccionar el mes a reportar</TextMessage>}
                            </FormControl>
                        </Box>
                        <Box mt={5} mb={2}>
                            <FormControl fullWidth sx={{textAlign: 'start'}}>
                                <TextField id="year" label="Año" placeholder="ingresa el año" value={year} onChange={handleChangeYear}></TextField>
                                {errorYear && <TextMessage>Debe contener valores de tipo numerico</TextMessage>}
                            </FormControl>
                        </Box>
                        { reporte == types.comercio ?
                            <Box mt={7} mb={2}>
                                <FormControl fullWidth sx={{textAlign: 'start'}}>
                                    <InputLabel id="commerceId">Comercio Id</InputLabel>
                                    <Select labelId="commerceId" id="select-commerceId" label="Comercio Id" value={commerceId} name={nameCommerce} onChange={handleChangeCommerceId}>
                                        {commerces?.map(commerce => (
                                            <MenuItem key={commerce.oldId} value={commerce.oldId} onClick={(event) => handleClickCommerce(commerce.name)}>{`${commerce.oldId}. ${commerce.name}`}</MenuItem>
                                        ))}
                                    </Select>
                                    {errorCommerceId && <TextMessage>Seleccionar el comercio</TextMessage>}
                                </FormControl>
                            </Box>
                            : null
                        }
                        { reporte == types.fondeo ?
                            <Box mt={7} mb={2}>
                                <FormControl fullWidth sx={{textAlign: 'start'}}>
                                    <InputLabel id="fondeadorId">Fondeador</InputLabel>
                                    <Select labelId="fondeadorId" id="select-fondeador" label="Fondeador" value={fondeadorUuid} name={fondeadorName} onChange={handleChangeFondeadorUuid}>
                                        {fondeadores?.map(fondeador => (
                                            <MenuItem key={fondeador.id} value={fondeador.uuid} onClick={(event) => handleFondeadorClick(fondeador)}>{`${fondeador.id}. ${fondeador.name}`}</MenuItem>
                                        ))}
                                    </Select>
                                    {errorFondeadorUuid && <TextMessage>Seleccionar el fondeador</TextMessage>}
                                </FormControl>
                        </Box>
                        : null
                        }
                        <ButtonDownloand variant="contained" endIcon={<DownloadIcon></DownloadIcon>} type="submit">Generar Reporte</ButtonDownloand>
                    </form>
                </Box>
            </Container>
            </Box>
        </React.Fragment>
    )
}